// extracted by mini-css-extract-plugin
module.exports = {"inputWrap":"FormPassword_inputWrap__Vq__R","input":"FormPassword_input__cQ_yu","root--error":"FormPassword_root--error__11D5X","rotation":"FormPassword_rotation__6ugDM"};